/**
 * abui-input-count
 */
$(function() {
  $('input.input-count').abuiInputCount()
});

(function() {
  $.fn.abuiInputCount = function() {
    return this.each(function() {
      const $input = $(this);
      const dataMax = parseInt( $input.data('max') );

      if (!dataMax) return;

      const $parent = $input.parent('.form-group');
      const $count = $('<div class="form-count"/>');

      const checkNum = function() {
        let inputLength = $input.val().length;
        let remainNum = dataMax - inputLength;

        $count.text( remainNum )
        $parent.toggleClass('has-error', remainNum < 0);
      }

      $count.text( dataMax )
      $input.after( $count )

      $input.on('keydown keyup keypress change', checkNum)
      checkNum()
    })
  }
})();

